module.exports = __webpack_public_path__ + "img/5.3fb23cd3.jpg";